import * as Sentry from '@sentry/react'
import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

// AppShell stays outside this boundary, so users can always navigate away.
export default function RouteErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <Box sx={{ maxWidth: 480, mx: 'auto', mt: 6, textAlign: 'center' }}>
          <Typography variant="h6" sx={{ mb: 1 }}>Something went wrong</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            This page hit an unexpected error. Try again, or head back to Today.
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={() => { resetError(); window.location.assign('/today') }}
            >
              Back to Today
            </Button>
            <Button variant="contained" onClick={resetError}>Try again</Button>
          </Box>
        </Box>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
